import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { FaPaperPlane, FaEnvelope, FaMapMarkerAlt, FaPhoneAlt, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import emailjs from '@emailjs/browser'; // Import EmailJS
import styles from './Contact.module.css';

const Contact = () => {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null); // Success/Error message dikhane ke liye

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    // 🔴 NIche Apni EmailJS Keys Daalna
    emailjs.sendForm(
      'service_51bmxwy',    // Example: 'service_xyz'
      'template_yluvvzb',   // Example: 'template_abc'
      formRef.current,
      'kxwllkZHMsHJQlQOn'     // Example: 'user_123456'
    )
    .then((result) => {
      setLoading(false);
      setMessage({ type: 'success', text: 'Message Sent Successfully!' });
      e.target.reset(); // Form clear kar do
      
      // 5 second baad message hata do
      setTimeout(() => setMessage(null), 5000);
    }, (error) => {
      setLoading(false);
      setMessage({ type: 'error', text: 'Something went wrong. Try again.' });
      console.error(error.text);
    });
  };

  return (
    <section id="contact" className={styles.contactSection}>
      <div className={styles.container}>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className={styles.header}
        >
          <h2 className="text-gradient">Get In Touch</h2>
          <p className={styles.subtitle}>Have a project in mind? Let's build something epic.</p>
        </motion.div>

        <div className={styles.contentWrapper}>
          
          {/* Left Side: Contact Info */}
          <motion.div 
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            className={styles.contactInfo}
          >
            <div className={styles.infoCard}>
              <div className={styles.iconBox}><FaEnvelope /></div>
              <div>
                <h4>Email Me</h4>
                <a href="mailto:ppatel3735@gmail.com">ppatel3735@gmail.com</a>
              </div>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.iconBox}><FaPhoneAlt /></div>
              <div>
                <h4>Call Me</h4>
                <p>+91 97148 65744</p>
              </div>
            </div>

            <div className={styles.infoCard}>
              <div className={styles.iconBox}><FaMapMarkerAlt /></div>
              <div>
                <h4>Location</h4>
                <p>Surat, Gujarat, India</p>
              </div>
            </div>
          </motion.div>

          {/* Right Side: Message Form */}
          <motion.form 
            ref={formRef} // Form Reference Link kiya
            onSubmit={sendEmail} // Submit Handler
            initial={{ x: 50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            className={`${styles.form} glass`}
          >
            <div className={styles.inputGroup}>
              {/* Name attribute zaroori hai EmailJS ke liye */}
              <input type="text" name="user_name" placeholder="Your Name" required className={styles.input} />
            </div>
            <div className={styles.inputGroup}>
              <input type="email" name="user_email" placeholder="Your Email" required className={styles.input} />
            </div>
            <div className={styles.inputGroup}>
              <textarea name="message" placeholder="Your Message" rows="5" required className={styles.textarea}></textarea>
            </div>
            
            <button type="submit" className={styles.submitBtn} disabled={loading}>
              {loading ? 'Sending...' : <>Send Message <FaPaperPlane /></>}
            </button>

            {/* Success/Error Message Popup */}
            {message && (
              <div style={{ 
                marginTop: '1rem', 
                padding: '10px', 
                borderRadius: '8px', 
                background: message.type === 'success' ? 'rgba(34, 197, 94, 0.2)' : 'rgba(239, 68, 68, 0.2)',
                color: message.type === 'success' ? '#4ade80' : '#f87171',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                {message.type === 'success' ? <FaCheckCircle /> : <FaExclamationCircle />}
                {message.text}
              </div>
            )}
          </motion.form>

        </div>
      </div>
    </section>
  );
};

export default Contact;